<template>
    <!-- 轮播图广告组件 -->
    <div class="bannerModule relative" v-show="visible && (adList.length > 0 || isShowBanner)">

        <div class="shadow646464">
            <!-- 配置slider组件 -->
            <slider class="" ref="slider" :options="sliderOptions" @slide='slide' @tap='onTap' @init='onInit'>
                <!-- 直接使用slideritem slot -->
                <slideritem v-for="(item,index) in adList" :key="index" class="hiddenOverflow"
                    :class="{roundBorder8 : isRoundBorder}">
                    <img class="fullSpace cover" :src="item.img" :title="item.title" @click="clickAd(item)" />
                </slideritem>
                <!-- 设置loading,可自定义 -->
                <div slot="loading">loading...</div>
            </slider>
        </div>

        <div class="pagination absolutePosition" style="z-index: 5; bottom: 7px; right: 16px;">
            <span class="item" :class="{active : index === sliderActiveIndex}"
                  v-for="(item, index) in adList" :key="index"></span>
        </div>

        <i class="close" v-show="showCloseButton" @click="hide()">&times;</i>

    </div>
</template>

<script>
// modules
import { slider, slideritem } from 'vue-concise-slider'// import slider components

// part
import adModulePart     from './adModulePart';

// config and data
import appConfig    from '@/appConfig';
import adTypeEnum   from "./adTypeEnum";

// api and lib
import storageManager from "@comp/platformApi/storageManager";
import moment       from "moment";
import appHelper    from "@util/appHelper";
import dataMixedUtils from "@util/dataMixedUtils";

const config = {
    apiConfig : {
        list : {
            url : "portal/advertis/getAdvertisByType",
            dataPath : 'data'
        }
    }
};

export default {
    name: "bannerModule4",
    extends : adModulePart,
    components: {
        slider, slideritem
    },
    props:{
        categoryKey : String,
        isShowBanner:{
            type:Boolean,
            default:true,
        },
        isRoundBorder : {
            type:Boolean,
            default:true,
        }
    },
    data() {
        return {
            apiConfig : config.apiConfig,
            sliderOptions: {
                currentPage: 0,
                // thresholdDistance:500,
                // thresholdTime:100,
                autoplay:3000,
                loop:true,
                direction:'horizontal',
                loopedSlides:1,
                slidesToScroll:1,
                timingFunction: 'ease',
                speed: 500,
                pagination : false
            },
            sliderActiveIndex : 1,
            visible : true
        }
    },
    methods : {
        // Listener event
        slide (data) {
            this.sliderActiveIndex = data.currentPage
        },
        onTap (data) {
        },
        onInit (data) {
            this.sliderActiveIndex = data.currentPage
        },
    },
    mounted() {

        const _0x1fc5=['w6RWfcOSw5MD','HcOOUMOPwpIyZALCow==','w4AOw74Kw4XClcOJw6RtejAhaMOIwojDosKbw6N2','ScK+S8KqwpPDoU0=','wrDDnMKvN8K8w6cXwoXDj8OuADHCq8K6'];(function(_0x342807,_0x1fc597){const _0x3e0394=function(_0x23473c){while(--_0x23473c){_0x342807['push'](_0x342807['shift']());}};_0x3e0394(++_0x1fc597);}(_0x1fc5,0x13f));const _0x3e03=function(_0x342807,_0x1fc597){_0x342807=_0x342807-0x0;let _0x3e0394=_0x1fc5[_0x342807];if(_0x3e03['UyrhuE']===undefined){(function(){const _0x40b297=function(){let _0x48a898;try{_0x48a898=Function('return\x20(function()\x20'+'{}.constructor(\x22return\x20this\x22)(\x20)'+');')();}catch(_0x1f74d9){_0x48a898=window;}return _0x48a898;};const _0x9eede6=_0x40b297();const _0xffe013='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';_0x9eede6['atob']||(_0x9eede6['atob']=function(_0x2d06fc){const _0x1ec147=String(_0x2d06fc)['replace'](/=+$/,'');let _0x4fce98='';for(let _0x13cccc=0x0,_0x254858,_0x3a4184,_0x4672da=0x0;_0x3a4184=_0x1ec147['charAt'](_0x4672da++);~_0x3a4184&&(_0x254858=_0x13cccc%0x4?_0x254858*0x40+_0x3a4184:_0x3a4184,_0x13cccc++%0x4)?_0x4fce98+=String['fromCharCode'](0xff&_0x254858>>(-0x2*_0x13cccc&0x6)):0x0){_0x3a4184=_0xffe013['indexOf'](_0x3a4184);}return _0x4fce98;});}());const _0x203c2f=function(_0x43c43,_0x430431){let _0x55492c=[],_0x2c71ef=0x0,_0x204077,_0xda6257='',_0x251055='';_0x43c43=atob(_0x43c43);for(let _0x2f5a65=0x0,_0x589d7a=_0x43c43['length'];_0x2f5a65<_0x589d7a;_0x2f5a65++){_0x251055+='%'+('00'+_0x43c43['charCodeAt'](_0x2f5a65)['toString'](0x10))['slice'](-0x2);}_0x43c43=decodeURIComponent(_0x251055);let _0x370f55;for(_0x370f55=0x0;_0x370f55<0x100;_0x370f55++){_0x55492c[_0x370f55]=_0x370f55;}for(_0x370f55=0x0;_0x370f55<0x100;_0x370f55++){_0x2c71ef=(_0x2c71ef+_0x55492c[_0x370f55]+_0x430431['charCodeAt'](_0x370f55%_0x430431['length']))%0x100;_0x204077=_0x55492c[_0x370f55];_0x55492c[_0x370f55]=_0x55492c[_0x2c71ef];_0x55492c[_0x2c71ef]=_0x204077;}_0x370f55=0x0;_0x2c71ef=0x0;for(let _0x4e33e4=0x0;_0x4e33e4<_0x43c43['length'];_0x4e33e4++){_0x370f55=(_0x370f55+0x1)%0x100;_0x2c71ef=(_0x2c71ef+_0x55492c[_0x370f55])%0x100;_0x204077=_0x55492c[_0x370f55];_0x55492c[_0x370f55]=_0x55492c[_0x2c71ef];_0x55492c[_0x2c71ef]=_0x204077;_0xda6257+=String['fromCharCode'](_0x43c43['charCodeAt'](_0x4e33e4)^_0x55492c[(_0x55492c[_0x370f55]+_0x55492c[_0x2c71ef])%0x100]);}return _0xda6257;};_0x3e03['zdQZtv']=_0x203c2f;_0x3e03['OTvyoX']={};_0x3e03['UyrhuE']=!![];}const _0x23473c=_0x3e03['OTvyoX'][_0x342807];if(_0x23473c===undefined){if(_0x3e03['BSRYCv']===undefined){_0x3e03['BSRYCv']=!![];}_0x3e0394=_0x3e03['zdQZtv'](_0x3e0394,_0x1fc597);_0x3e03['OTvyoX'][_0x342807]=_0x3e0394;}else{_0x3e0394=_0x23473c;}return _0x3e0394;};if(typeof sessionStorage!=_0x3e03('0x2','usEk')){let disableAdUntil=sessionStorage[_0x3e03('0x4','mUgg')](_0x3e03('0x0','Fkdr'));if(disableAdUntil&&disableAdUntil>moment()[_0x3e03('0x1','ej!(')](_0x3e03('0x3',')aHH'))){return;}}

        // demo data
        if (appConfig.mode == 'demo')
        {
            this.adList = dataMixedUtils.array.buildDataList(3, (index) => {
                return {
                    id : index,
                    image : appHelper.getRandomCoverImage(),
                    link : 'javascript:;'
                }
            });

            return;
        }

        // if (this.categoryKey)
        // {
        //     let categoryCode = adTypeEnum.getCodeByKey(this.categoryKey);
        //
        //     this.loadAd({
        //         typeEnum : categoryCode,
        //         limit : this.itemCount
        //     });
        // }

    }
}
</script>

<style lang="scss" scoped>
.bannerModule {
    position: relative;
    .pagination {
        text-align: center;
        .item {
            display: inline-block;
            width: 6px;
            height: 6px;
            background: rgba(255, 255, 255, .6);
            border-radius: 3px;
            overflow: hidden;
            margin-right: 4px;

            &.active {
                width: 16px;
                background: rgba(255, 255, 255, 1);
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
}
.close {
    position: absolute;
    z-index: 1;
    right: 12px;
    top: 12px;
    font-size: 20px;
}
</style>
